<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="400">
    <v-card v-if="values != null">
      <ODialogBar title="Referência de Valores" @close="dismiss" />
      <v-card-text class="pa-3">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Item</th>
                <th class="text-right">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="values.length < 1">
                <td colspan="2">
                  Não existem itens para o técnico/centro de custo selecionados.
                </td>
              </tr>
              <tr
                class="clickable"
                v-for="item in values"
                :key="item.name"
                @click="apply(item.value)"
              >
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.value | brDec }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { CostCenter, Technician } from '../../../models'
import { brDec } from 'oderon-commons/src/formatters.js'

export default {
  data() {
    return { values: null }
  },
  filters: {
    brDec(x) {
      return Number.isFinite(x) ? brDec(x) : '─'
    }
  },
  methods: {
    async openTech(id) {
      if (id == null) return null
      this.values = null
      this.$refs.dialog.$loading(async () => {
        let row = await Technician.findById(id)
        this.values = row.values || []
      })

      return this.$refs.dialog.$open()
    },
    async openCostCenter(id) {
      if (id == null) return null
      this.values = null
      this.$refs.dialog.$loading(async () => {
        let row = await CostCenter.findById(id)
        let props = {
          cardValue: 'Crachá',
          monthlyValue: 'Mensalidade',
          installValue: 'Instalação',
          removeValue: 'Retirada'
        }
        this.values = Object.keys(props).map((x) => ({
          name: props[x],
          value: row[x]
        }))
      })

      return this.$refs.dialog.$open()
    },
    apply(x) {
      this.$refs.dialog.$apply(x)
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
